import { Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-loading',
  imports: [TranslocoModule],
  templateUrl: './loading.component.html',
})
export class LoadingComponent {
  @Input() scope = 'emailVerification';
}
